import { useDispatch, useSelector } from 'react-redux'
import {
  scrubItem,
  scrubMydecor
} from '../redux/designerReducers/assetsReducer'
import { adjustSizingForStageAdvance } from '../utils/nodeUtils'
import {
  addTarget,
  changeTargetImage
} from '../redux/designerReducers/canvasReducer'
import { logEvent } from '../utils/firebase'
import { useIsTutorial } from './useIsTutorial'

const useItem = () => {
  const dispatch = useDispatch()
  const isTutorial = useIsTutorial()
  const {
    sceneWidth,
    sceneHeight,
    sceneZoomWidth,
    sceneZoomHeight,
    markers,
    selectedBubble
  } = useSelector(state => state.canvas)

  const calculateImageSize = (image, superViewWidth, forRug) => {
    const largest = Math.max(image.width, image.height)
    const ratio = superViewWidth / largest

    let height = 0
    let width = 0

    if (forRug) {
      // scaleBtnWidth provides inset
      height = image.height * ratio - 40
      width = image.width * ratio - 40
    } else {
      height = (image.height * ratio) / 3
      width = (image.width * ratio) / 3
    }

    if (isTutorial) {
      height *= 2.6
      width *= 2.6
    }

    return { width, height }
  }

  const createItemAndDrag = (e, src, data, type = 'item') => {
    logEvent('item_selected', {
      content_type: 'item',
      content_id: data.objectId || data.item.objectId
    })

    var item
    switch (type) {
      case 'item':
        item = scrubItem(data)
        break
      case 'mydecor':
        item = scrubMydecor(data)
        break
      default:
        item = scrubItem(data)
    }

    const obj = {
      src,
      item
    }

    e.dataTransfer.setData('text/plain', JSON.stringify(obj))
    e.currentTarget.style.opacity = 0.1
  }

  const createItemAndAddTarget = async (
    src,
    data,
    type = 'item',
    mode = 'add',
    options
  ) => {
    logEvent('item_selected', {
      content_type: 'item',
      content_id: data.objectId || data.item.objectId
    })

    const img = new Image()
    img.src = src
    await img.decode()

    var item
    switch (type) {
      case 'item':
        item = scrubItem(data)
        break
      case 'mydecor':
        item = scrubMydecor(data)
        break
      default:
        item = scrubItem(data)
    }

    const [imgW, imgH, scale] = adjustSizingForStageAdvance(
      sceneWidth,
      sceneHeight,
      img.naturalWidth,
      img.naturalHeight,
      item.categoryId,
      item.subcategoryId
    )

    const dims = calculateImageSize(
      { width: img.naturalWidth, height: img.naturalHeight },
      sceneWidth,
      false
    )

    const bubble = markers.find(item => item?.id === selectedBubble)

    const scaleDynamicX =
      !isTutorial && bubble?.frame?.dimensions
        ? (bubble?.frame?.dimensions[0] * 1.5) / img.naturalWidth
        : scale

    const scaleDynamicY =
      !isTutorial && bubble?.frame?.dimensions
        ? (bubble?.frame?.dimensions[1] * 1.5) / img.naturalHeight
        : scale

    let x = options?.x ? options?.x : sceneZoomWidth / 2
    let y = options?.y ? options?.y : sceneZoomHeight / 2

    if (bubble && !isTutorial) {
      x = bubble?.x * 2
      y = bubble?.y * 2
    }

    const obj = {
      src: src,
      x,
      y,
      width: bubble?.frame?.dimensions
        ? bubble?.frame?.dimensions[0]
        : dims.width,
      height: bubble?.frame?.dimensions
        ? bubble?.frame?.dimensions[1]
        : dims.height,
      scaleX: scaleDynamicX,
      scaleY: scaleDynamicY,
      item,
      bubble,
      isTutorial
    }

    if (mode === 'change') {
      dispatch(changeTargetImage(obj))
      return
    }
    dispatch(addTarget(obj))
  }

  return { createItemAndDrag, createItemAndAddTarget }
}

export default useItem
